/* eslint-disable no-console */
/* eslint-disable no-use-before-define */

import Api from 'lib/api';
import { EventTypes } from 'redux-segment';

// ------------------------------------
// Constants
// ------------------------------------
const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
// const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';

const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';

const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

const LOGOUT_USER = 'LOGOUT_USER';

const REQUEST_MAGIC_LINK = 'REQUEST_MAGIC_LINK';

const USER_ADDRESS_REQUEST = 'USER_ADDRESS_REQUEST';
const USER_ADDRESS_SUCCESS = 'USER_ADDRESS_SUCCESS';

const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';

const LOAD_PROFILE_REQUEST = 'LOAD_PROFILE_REQUEST';
const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';

const SET_DEFAULT_ADDRESS_REQUEST = 'SET_DEFAULT_ADDRESS_REQUEST';
const SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS = 'SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS';
const SET_DEFAULT_BILLING_ADDRESS_SUCCESS = 'SET_DEFAULT_BILLING_ADDRESS_SUCCESS';

const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST';
const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';

const ADD_ADDRESS_REQEUST = 'ADD_ADDRESS_REQEUST';
const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';

const ORDER_HISTORY_REQUEST = 'ORDER_HISTORY_REQUEST';
const ORDER_HISTORY_SUCCESS = 'ORDER_HISTORY_SUCCESS';

const ORDER_REQUEST = 'ORDER_REQUEST';
const ORDER_SUCCESS = 'ORDER_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------
const requestLogin = creds => ({
  type: LOGIN_REQUEST,
  isAuthenticated: false,
  creds
});

const receiveLogin = (user) => {
  user.isAuthenticated = true;
  localStorage.setItem('user', JSON.stringify(user));
  return {
    type: LOGIN_SUCCESS,
    user,
    meta: {
      analytics: {
        eventType: EventTypes.identify,
        eventPayload: {
          userId: user.id,
          traits: {
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName
          }
        }
      }
    }
  };
};

const requestCreateUser = user => ({
  type: CREATE_USER_REQUEST,
  user
});

// const receiveCreateUser = user => ({
//   type: CREATE_USER_SUCCESS,
//   user
// });

const requestVerifyEmail = email => ({
  type: VERIFY_EMAIL_REQUEST,
  email
});

const requestPasswordReset = email => ({
  type: RESET_PASSWORD_REQUEST,
  email
});

const logout = () => ({
  type: LOGOUT_USER,
});

const requestMagicLink = email => ({
  type: REQUEST_MAGIC_LINK,
  email
});

const receiveAddresses = addresses => ({
  type: USER_ADDRESS_SUCCESS,
  addresses
});

const receiveUpdateProfile = profile => ({
  type: UPDATE_PROFILE_SUCCESS,
  profile
});

const receiveLoadProfile = profile => ({
  type: LOAD_PROFILE_SUCCESS,
  profile
});

const setDefaultShippingAddress = address => ({
  type: SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS,
  address
});

const setDefaultBillingAddress = address => ({
  type: SET_DEFAULT_BILLING_ADDRESS_SUCCESS,
  address
});

const receiveUpdateAddress = address => ({
  type: UPDATE_ADDRESS_SUCCESS,
  address
});

const receiveAddAddress = address => ({
  type: ADD_ADDRESS_SUCCESS,
  address
});

const requestOrderHistory = () => ({
  type: ORDER_HISTORY_REQUEST
});

const receiveOrderHistory = orders => ({
  type: ORDER_HISTORY_SUCCESS,
  orders
});

const requestOrder = orderId => ({
  type: ORDER_REQUEST,
  orderId
});

const receiveOrder = order => ({
  type: ORDER_SUCCESS,
  order
});

// ------------------------------------
// Helpers
// ------------------------------------

const logoutUser = () => (dispatch) => {
  localStorage.removeItem('user');
  dispatch(logout());
};

const createCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
};

const loginUser = (creds, fullProfile = true) => (dispatch) => {
  dispatch(requestLogin(creds));

  return Api.post('/users/login', creds).then((resp) => {
    if (resp.authToken !== undefined) {
      dispatch(receiveLogin(resp));
      // Set cookies
      createCookie('_frn_authToken', resp.authToken, 365);


      if (fullProfile) {
        dispatch(loadAddresses());
        dispatch(loadProfile(resp.authToken));
      }

      return resp.fullAuth;
    }
    console.log('Login failed');
    return false;
  }).catch((err) => {
    console.log(err);
  });
};

const loadAddresses = () => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch({ type: USER_ADDRESS_REQUEST });
  return Api.get('/users/current/addresses', token).then((resp) => {
    if (Array.isArray(resp)) {
      dispatch(receiveAddresses(resp));
    }
  }).catch((error) => {
    console.log(error);
  });
};

const createUser = user => (dispatch) => {
  dispatch(requestCreateUser(user));

  return Api.post('/users', user).then((resp) => {
    console.log('resp on user create: ', resp);
    let userCreated = false;
    if (resp.id !== undefined) {
      const respUser = {
        email: resp.email,
        firstName: resp.firstName,
        lastName: resp.lastName,
        authToken: resp.authToken,
        fullAuth: true
      };
      dispatch(receiveLogin(respUser));
      userCreated = true;
    }

    return userCreated;
  }).catch((err) => {
    console.log(err);
  });
};

const verifyEmail = email => (dispatch) => {
  dispatch(requestVerifyEmail(email));

  return Api.post('/users/verify', { email }).then((resp) => {
    let verifiedEmail = false;
    if (resp.found !== undefined) {
      dispatch({ type: VERIFY_EMAIL_SUCCESS });
      verifiedEmail = true;
    }

    return verifiedEmail;
  }).catch((err) => {
    console.log(err);
  });
};

const resetPassword = email => (dispatch) => {
  dispatch(requestPasswordReset(email));

  // This would be an API call and then determine success based on response
  return new Promise((resolve) => {
    setTimeout(() => {
      dispatch({ type: RESET_PASSWORD_SUCCESS });

      resolve();
    }, 300);
  });
};

const sendMagicLink = email => dispatch => Api.post('/users/sendMagicLink', { email }).then(() => {
  dispatch(requestMagicLink(email));
  return true;
}).catch((error) => {
  console.log(error);
});

const updateProfile = (profile, token) => (dispatch) => {
  dispatch({ type: UPDATE_PROFILE_REQUEST });
  return Api.patch('/users/current', profile, token).then((resp) => {
    if (resp.status === undefined) {
      // we got a json object
      dispatch(receiveUpdateProfile(resp));
      return true;
    }
    // there was an error, most likely unauthorized
    console.log(resp);
    return null;
  }).catch((error) => {
    console.log(error);
    return null;
  });
};

const loadProfile = token => (dispatch) => {
  dispatch({ type: LOAD_PROFILE_REQUEST });
  return Api.get('/users/current/profile', token).then((resp) => {
    if (resp.status === undefined) {
      dispatch(receiveLoadProfile(resp));
      return true;
    }
    console.log(resp);
    return null;
  }).catch((error) => {
    console.log(error);
    return null;
  });
};

const setDefaultAddress = address => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch({ type: SET_DEFAULT_ADDRESS_REQUEST });
  return Api.put(`/users/current/addresses/${address.id}/makeDefault`, null, token).then((resp) => {
    if (resp.status === 204) {
      address.type === 'shipping' ?
        dispatch(setDefaultShippingAddress(address)) :
        dispatch(setDefaultBillingAddress(address));
    } else {
      console.log(resp);
    }
  }).catch((error) => {
    console.log(error);
  });
};

const updateAddress = address => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch({ type: UPDATE_ADDRESS_REQUEST });
  return Api.patch(`/users/current/addresses/${address.id}`, address, token).then((resp) => {
    if (resp.status === undefined) {
      dispatch(receiveUpdateAddress(resp));
      return true;
    }
    console.log(resp);
    return null;
  }).catch((error) => {
    console.log(error);
    return null;
  });
};

const addAddress = address => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch({ type: ADD_ADDRESS_REQEUST });
  return Api.post('/users/current/addresses', address, token).then((resp) => {
    if (resp.status === undefined) {
      dispatch(receiveAddAddress(resp));
      return true;
    }
    console.log(resp);
    return true;
  }).catch((error) => {
    console.log(error);
    return null;
  });
};

const loadOrderHistory = () => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch(requestOrderHistory());
  return Api.get('/users/current/orders', token).then((resp) => {
    if (resp.status === undefined) {
      dispatch(receiveOrderHistory(resp));
    } else {
      console.log(resp);
    }
  }).catch((error) => {
    console.log(error);
  });
};

const loadOrder = orderId => (dispatch, getState) => {
  const token = getState().user.authToken;
  dispatch(requestOrder(orderId));

  return Api.get(`/users/current/orders/${orderId}`, token).then((resp) => {
    if (resp.status === undefined) {
      dispatch(receiveOrder(resp));
    } else {
      console.log(resp);
    }
  }).catch((error) => {
    console.log(error);
  });
};

// ------------------------------------
// Action Handlers
// ------------------------------------
export const actions = {
  loginUser,
  verifyEmail,
  resetPassword,
  logoutUser,
  createUser,
  sendMagicLink,
  loadAddresses,
  updateProfile,
  loadProfile,
  setDefaultAddress,
  updateAddress,
  addAddress,
  receiveUpdateProfile,
  receiveLogin,
  loadOrderHistory,
  loadOrder
};

// ------------------------------------
// Reducer
// ------------------------------------

let initialState = {
  isAuthenticated: false,
  email: '',
  authToken: '',
  firstName: '',
  lastName: '',
  fullAuth: false,
  DefaultShippingAddress: { id: 0 },
  DefaultBillingAddress: { id: 0 },
  UserPaymentMethods: [],
  addresses: [],
  orders: [],
  selectedOrder: null
};

if ('checkout' === window.location.pathname.slice(1, 9)) {
  localStorage.clear();
} else {
  try {
    const preParseStoredUser = !!localStorage && localStorage.getItem('user');
    if (preParseStoredUser) {
      const storedUser = JSON.parse(preParseStoredUser);
      initialState = {
        ...initialState,
        ...storedUser
      };
    }
  } catch (err) {
    console.log('localStorage lookup user error: ', err);
  }
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case ORDER_SUCCESS:
      return {
        ...state,
        selectedOrder: action.order
      };
    case ORDER_REQUEST:
      return {
        ...state,
        selectedOrder: {
          id: action.orderId
        }
      };
    case ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        orders: action.orders
      };
    case ADD_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: [...state.addresses, action.address]
      };
    case UPDATE_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: state.addresses.map(address => (address.id === action.address.id ? action.address : address))
      };
    case SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS:
      return {
        ...state,
        DefaultShippingAddress: action.address
      };
    case SET_DEFAULT_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        DefaultBillingAddress: action.address
      };
    case LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        email: action.profile.email,
        firstName: action.profile.firstName,
        lastName: action.profile.lastName,
        DefaultShippingAddress: action.profile.DefaultShippingAddress,
        DefaultBillingAddress: action.profile.DefaultBillingAddress,
        UserPaymentMethods: action.profile.UserPaymentMethods
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        email: action.profile.email,
        firstName: action.profile.firstName,
        lastName: action.profile.lastName
      };
    case USER_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: action.addresses
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        email: action.creds.email,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        authToken: action.user.authToken,
        email: action.user.email,
        firstName: action.user.firstName,
        lastName: action.user.lastName,
        fullAuth: action.user.fullAuth,
      };
    case VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        email: action.email
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        email: action.email
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetEmailSent: true
      };
    case LOGOUT_USER:
      return {
        ...state,
        isAuthenticated: false,
        email: '',
        authToken: '',
        firstName: '',
        lastName: '',
        fullAuth: false,
        form: {}

      };
    case REQUEST_MAGIC_LINK:
      return {
        ...state,
        email: action.email
      };
    default:
      return state;
  }
}

/* eslint-enable no-console */
/* eslint-enable no-use-before-define */



// WEBPACK FOOTER //
// ./modules/user.js